import { storeToRefs } from 'pinia'
import { useDevice } from '@/hooks/useDevice'
import { useLanguageStore } from '@/store/modules/language'
import { useAuthStore } from '@/store/modules/auth'
import { useGameStore } from '@/store/modules/game'

export const UseReportData = () => {
  const { currentGameConfig } = storeToRefs(useGameStore())
  const { verifyRole } = storeToRefs(useAuthStore())
  const { isMobileReal, isIOS, isAndroid, isHarmony } = useDevice()
  const { currentLanguage, currentCountry } = useLanguageStore()

  const $customEvent = (type: string, params: Object) => {
    const data = {
      time: new Date().getTime(),
      login_status: verifyRole.value.cUid ? 1 : 0,
      game_id: currentGameConfig.value.usdkId,
      user_id: verifyRole.value.cUid,
      cp_uid: verifyRole.value.cpUid,
      channel_id: verifyRole.value.cid,
      role_id: verifyRole.value.role_id,
      role_name: verifyRole.value.role_name,
      server_id: verifyRole.value.server_id,
      server_name: verifyRole.value.server_name,
      platform: isMobileReal.value ? 'mobile' : 'pc',
      // eslint-disable-next-line no-nested-ternary
      system: isIOS() ? 'ios' : isAndroid.value ? 'android' : isHarmony.value ? 'harmony' : 'web',
      web_source: localStorage.getItem('source') || '',
      tid: localStorage.getItem('hero_tid') || '',
      hero_r: localStorage.getItem('hero_ri') || '',
      hero_pri: localStorage.getItem('hero_pri')  || '',
      user_source: document.referrer,
      game_name: currentGameConfig.value.name,
      lang: currentLanguage.key,
      lang_label: currentLanguage.label,
      area: currentCountry.key,
      area_label: currentCountry.label,
      version: process.env.APP_VERSION,
      ...params
    }
    const nowType = `${process.env.VUE_APP_AREA}_${type}`
    window.staticFn.customEvent(nowType, data)
  }

  return {
    $customEvent
  }
}
